<template>
  <div>
    <div class="section-info">
      <div class="f-s-1_1 text-green m-b-10">
        <i class="el-icon-question"></i> 学生账号说明
      </div>
      1. 学生可在绑定后使用账号密码登录学生端；若绑定了多个微信/手机，都可以进行登录使用。 <br>
      2. 教师可以帮助学生重置登录密码，密码将统一重置为{{password}}。该操作将向绑定手机发送短信通知。
    </div>
    <div class="flex-layout section-header">
      <div>
        <i class="el-icon-document"></i>
        班级详情
        <template v-if="group">
          - {{getGroupName(group.name)}}
          共{{students.length}}人
        </template>
      </div>
      <div>
        <el-input v-model="search" suffix-icon="el-icon-search"
                  placeholder="搜索学生" style="width: 220px"/>
        <el-dropdown split-button type="primary" trigger="click"
                     @click="exportExcel()" :disabled="loading" class="m-h-10">
          导出名单Excel
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native.stop="exportWord()" :disabled="loading">
              导出名单
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button @click="$router.back()" :disabled="loading">返回</el-button>
      </div>
    </div>
    <el-table :data="pagedStudents">
      <el-table-column label="姓名" prop="name"/>
      <el-table-column label="学号" prop="number"/>
      <el-table-column label="是否绑定" prop="wechat.length">
        <template slot-scope="scope">
          <span v-if="scope.row.wechat.length" class="text-green">是</span>
          <span v-else class="text-red">否</span>
        </template>
      </el-table-column>
      <el-table-column label="登录账号" prop="wechat.0.mobile">
        <template slot-scope="scope">
          <template v-if="scope.row.wechat.length">
            {{maskPhone(scope.row.wechat[0].mobile)}}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" type="expand">
        <template slot-scope="scope">
          <template v-if="scope.row.wechat.length">
            <el-table :data="scope.row.wechat" border>
              <el-table-column label="身份" prop="relationship"/>
              <el-table-column label="绑定时间" prop="time_modify"/>
              <el-table-column label="微信昵称" prop="nickname"/>
              <el-table-column label="登录账号" prop="mobile">
                <template slot-scope="scope">
                  {{maskPhone(scope.row.mobile)}}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="wechatScope">
                  <a class="link link-red m-h-5" @click="resetPassword(scope.row, wechatScope.row)">
                    重置密码
                  </a>
                  <a class="link link-red m-h-5" @click="unbind(scope.row, wechatScope.row)">
                    解除绑定
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div v-else class="text-center">无绑定</div>
        </template>
      </el-table-column>
    </el-table>
    <div class="text-center m-v-20" v-show="filteredStudents.length > pageSize">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="filteredStudents.length"/>
    </div>
  </div>
</template>
<script>
import {
  downloadExcelUrl,
  downloadGroupStudentsWord,
  getGroupDetail,
  getGroupName,
  maskPhone,
  studentResetPassword,
  studentUnbind
} from './api'
import ElTable from 'element-ui/lib/table'
import ElTableColumn from 'element-ui/lib/table-column'
import MessageBox from 'element-ui/lib/message-box'

export default {
  components: {
    ElTable,
    ElTableColumn,
  },
  data () {
    return {
      password: '123456',
      maskPhone,
      getGroupName,
      loading: false,
      /**
       * @type {{name: string, grade: string}}
       */
      group: undefined,
      uid: this.$query.uid,
      search: '',
      page: 1,
      pageSize: 20,
      ready: false,
    }
  },
  computed: {
    students () {
      return this.group ? this.group.students : []
    },
    filteredStudents () {
      if (!this.search) return this.students
      return this.students.filter(s => {
        return s.name.includes(this.search) ||
          s.number.includes(this.search)
      })
    },
    pagedStudents () {
      const { page, pageSize } = this
      return this.filteredStudents.slice((page - 1) * pageSize, page * pageSize)
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$guard()(async () => {
        this.group = await getGroupDetail({ group_uid: this.uid })
        this.ready = true
      })
    },
    exportExcel () {
      this.$guard()(async () => {
        location.href = await downloadExcelUrl({ group_uid: this.uid })
      })
    },
    exportWord () {
      this.$guard()(async () => {
        await downloadGroupStudentsWord(this.group.name, this.students)
      })
    },
    async resetPassword (student, wechat) {
      if (this.loading) return
      const message = `是否将<span class="text-red">${student.name}（${student.number}）</span>的登录账号<span class="text-red">${maskPhone(wechat.mobile)}</span>的密码重置为<span class="text-red">${this.password}</span>？`
      await MessageBox.confirm(message, {
        title: '重置密码',
        dangerouslyUseHTMLString: true,
        confirmButtonText: '是，确认重置',
      })
      if (this.loading) return
      this.$guard()(async () => {
        await studentResetPassword({
          student_uid: student.uid,
          mobile: wechat.mobile,
          password: this.password,
        })
        this.$message.success('重置密码成功！')
      })
    },
    async unbind (student, wechat) {
      if (this.loading) return
      if (!wechat.unionid) {
        this.$message.error('无法解绑')
        return
      }
      const message = `你确定要解绑学生<span class="text-red">${student.name}（${student.number}）</span>的，昵称为<span class="text-red">${wechat.nickname}</span>的微信吗？`
      await MessageBox.confirm(message, {
        title: '解除绑定',
        dangerouslyUseHTMLString: true,
        confirmButtonText: '是，确认解绑',
      })
      if (this.loading) return
      this.$guard()(async () => {
        await studentUnbind({
          user_uid: student.uid,
          unionid: wechat.unionid,
        })
        const index = student.wechat.indexOf(wechat)
        if (index > -1) {
          student.wechat.splice(index, 1)
        }
        this.$message.success('解绑成功！')
      })
    },
  },
}
</script>
<style lang="scss">
@import "~element-ui/packages/theme-chalk/src/table";
@import "~element-ui/packages/theme-chalk/src/table-column";
@import "~element-ui/packages/theme-chalk/src/message-box";
</style>
<style lang="scss" scoped>
.section-info {
  color: #000;
  background-color: #fff9e6;
  margin: 10px 0;
  padding: 20px;
}

.section-header {
  background-color: #f7f7f7;
  padding: 3px 10px;
  border: 1px solid #eee;
}

/deep/ .el-table__expanded-cell {
  &, &:hover {
    background-color: #f2f2f2 !important;
  }
}
</style>
